import { Component, Input} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PartnerAnalysisGroup4 } from 'src/app/assabil-kernel/models/entities/control-tables/partner-analysis-group4';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';



@Component({
    selector: 'partner-analysis-group4-lov',
    templateUrl: './partner-analysis-group4-lov.component.html',
    styleUrls: ['./partner-analysis-group4-lov.component.scss']
})


export class PartnerAnalysisGroup4LovComponent extends GenericLovComponent   {

    @Input() code         : string; 
    @Input() name         : string; 

    partnerAnalysisGroup4s: PartnerAnalysisGroup4[] = [];

    columns = [
        {  prop: 'partnerAnalysisGroup4Code', name: 'Code'},
        {  prop: 'name', name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<PartnerAnalysisGroup4LovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "partnerAnalysisGroup4";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.partnerAnalysisGroup4s = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : PartnerAnalysisGroup4){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
